import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";

export default function NotFound() {
  return (
    <main className="min-h-[60vh] flex items-center justify-center py-24" data-testid="not-found-page">
      <div className="container-x max-w-2xl text-center">
        <span className="inline-block text-[12px] font-bold uppercase tracking-[0.22em] text-teal">
          Page not found
        </span>
        <h1 className="mt-4 text-5xl md:text-6xl font-bold text-navy tracking-tight">
          404
        </h1>
        <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
          The page you were looking for has moved or is no longer available. Use the navigation above
          to find what you need, or head back to the home page.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-cta"
            className="btn-primary inline-flex items-center gap-2 px-5 py-3 rounded-lg font-semibold text-sm"
          >
            <Home size={16} /> Return Home
          </Link>
          <Link
            to="/pricing"
            data-testid="not-found-pricing-cta"
            className="btn-secondary inline-flex items-center gap-2 px-5 py-3 rounded-lg font-semibold text-sm"
          >
            View Pricing <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </main>
  );
}
